import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Highlight from '../components/highlight'
import Point from '../components/point'
import Accordion from '../components/accordion'
import Feature from '../components/feature'
import Check from '../components/check'
import Quote from '../components/quote'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Finbest</title>
        <meta name="description" content="Description of the website" />
        <meta property="og:title" content="Finbest" />
        <meta property="og:description" content="Description of the website" />
      </Helmet>
      <div className="home-hero">
        <header className="home-heading10">
          <Navbar
            link1="Products"
            link2="How it works"
            link3="Pricing"
            link4="Contact Us"
            brandingSrc="/techplanes_1.svg"
          ></Navbar>
        </header>
        <div className="home-content10">
          <div className="home-content11">
            <h1 className="home-title1">
              <span className="home-text100">Go online</span>
              <span>
                {' '}
                in just
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text102">3 days</span>
              <span> without lifting a finger</span>
            </h1>
            <span className="home-caption1">
              We build, launch, and manage your professional business website
              and SaaS tools — all done-for-you. You relax, we handle
              everything.
            </span>
            <div className="home-hero-buttons1">
              <div className="home-ios-btn1">
                <span className="home-caption2">Get My Website Now </span>
              </div>
              <div className="home-android-btn1">
                <span className="home-caption3">
                  Free Trial (Digital WebApp)
                </span>
              </div>
            </div>
          </div>
          <div className="home-images">
            <div className="home-column1">

              <img
                alt="pastedImage"
                src="/pastedimage-oy26-1500h.png"
                className="home-pasted-image1"
              />
            </div>
            <div className="home-column2">
              <img
                alt="pastedImage"
                src="/pastedimage-v31-1500h.png"
                className="home-pasted-image2"
              />
              <img
                alt="pastedImage"
                src="/pastedimage-c39.svg"
                className="home-pasted-image3"
              />
            </div>
            <div className="home-column3">
              <img
                alt="pastedImage"
                src="/pastedimage-iqnj.svg"
                className="home-pasted-image4"
              />
              <img
                alt="pastedImage"
                src="/pastedimage-06e.svg"
                className="home-pasted-image5"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="home-video1">
        <div className="home-content12">
          <div className="home-header1">
            <h2 className="home-text104">
              Features &amp; Advantages of using TechPlanes DigiPlus
            </h2>
          </div>
          <div className="home-video-container">
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{ width: '100%', height: 'auto', background: 'transparent' }}
            >
              <source src="/hero-animation.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
            <div className="home-heading-container">
              <div className="home-heading11">
                <span className="home-text105">
                  Manage your entire business online with TechPlanes&apos;s
                  DigiPlus
                </span>
                <span className="home-text106">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="home-explore1">
                <span className="home-text107">
                  Explore pricing plans -&gt;
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-stats">
        <div className="home-stat1">
          <span className="home-caption4">200k</span>
          <span className="home-description1">
            Lorem ipsum dolor sit ametconsectetur adipiscing
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div className="home-stat2">
          <span className="home-caption5">$3,5 billions</span>
          <span className="home-description2">
            Lorem ipsum dolor sit ametconsectetur adipiscing
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div className="home-stat3">
          <span className="home-caption6">10.000 +</span>
          <span className="home-description3">
            Lorem ipsum dolor sit ametconsectetur adipiscing
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
      </div>
      <div className="home-sections">
        <div className="home-section1">
          <div className="home-image1"></div>
          <div className="home-content13">
            <h2 className="home-text108">Why This is Perfect for You?</h2>
            <Highlight
              text={
                <Fragment>
                  <span className="home-text109">
                    <span>
                      You run your business. We build your digital world.
                    </span>
                    <br></br>
                    <span>
                      With zero learning curve, no setup time, and absolutely no
                      tech stress.
                    </span>
                    Everything you get with Finbest
                  </span>
                </Fragment>
              }
              title="Lorem ipsum dolor sit amet, consectetur "
              text1={
                <Fragment>
                  <span className="home-text113">
                    <span>✅ Professionally designed website</span>
                    <br></br>
                    <span>✅ Set up in just 3 days</span>
                    <br></br>
                    <span>✅ Mobile-ready and lightning fast</span>
                    <br></br>
                    <span>
                      ✅ We handle everything — so you don’t lift a finger
                    </span>
                  </span>
                </Fragment>
              }
              description="Sed do eiusmod tempor incididunt ut labore et dolore magna aliquat enim ad minim veniam, quis nostrud"
            ></Highlight>
            <div className="home-explore2">
              <span>Explore pricing plans -&gt;</span>
            </div>
          </div>
        </div>
        <div className="home-section2">
          <div className="home-content14">
            <div className="home-heading12">
              <h2 className="home-text122">Keep track with all transactions</h2>
              <span className="home-text123">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt.
              </span>
            </div>
            <div className="home-content15">
              <div className="home-points">
                <Point></Point>
                <Point text="Quis nostrud exercitation ullamco"></Point>
                <Point text="Reprehenderit qui in ea voluptate velit"></Point>
              </div>
              <Link to="/" className="home-navlink">
                <div className="home-get-started1">
                  <span className="home-sign-up">Get started now</span>
                </div>
              </Link>
            </div>
          </div>
          <div className="home-image2"></div>
        </div>
        <div className="home-section3">
          <div className="home-image3">
            <div className="home-image-overlay"></div>
          </div>
          <div className="home-content16">
            <h2 className="home-text124">
              <span>Create milestones</span>
              <br></br>
            </h2>
            <Accordion></Accordion>
          </div>
        </div>
      </div>
      <div className="home-banner-container">
        <div className="home-banner">
          <div className="home-overlay1">
            <span className="home-text127">
              Begin your financial journey on finbest
            </span>
            <div className="home-book-btn">
              <span className="home-text128">Book a demo</span>
            </div>
          </div>
          <img
            alt="pastedImage"
            src="/pastedimage-ylke.svg"
            className="home-pasted-image6"
          />
        </div>
      </div>
      <div className="home-features">
        <div className="home-header2">
          <div className="home-tag1">
            <span className="home-text129">Features</span>
          </div>
          <div className="home-heading13">
            <h2 className="home-text130">TechPlanes DigiPlus</h2>
            <span className="home-text131">
              Your Business, One App. No Complications.
            </span>
          </div>
        </div>
        <div className="home-feature-list">
          <Feature
            title="Customer"
            title1={
              <Fragment>
                <span className="home-text132">Customer</span>
              </Fragment>
            }
            thumbnail="/vector6113-r6dl.svg"
            title11={
              <Fragment>
                <span className="home-text133"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Customer"
            title1={
              <Fragment>
                <span className="home-text134">Appointments</span>
              </Fragment>
            }
            thumbnail="/vector6113-r6dl.svg"
            title11={
              <Fragment>
                <span className="home-text135"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Analytics"
            title1={
              <Fragment>
                <span className="home-text136">Invoicing</span>
              </Fragment>
            }
            thumbnail="/vector6113-6zj.svg"
            title11={
              <Fragment>
                <span className="home-text137"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Virtual Card"
            title1={
              <Fragment>
                <span className="home-text138">Inventory</span>
              </Fragment>
            }
            thumbnail="/vector6113-lvvs.svg"
            title11={
              <Fragment>
                <span className="home-text139"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Safe Transactions"
            title1={
              <Fragment>
                <span className="home-text140">Expenses</span>
              </Fragment>
            }
            thumbnail="/vector6114-cupp.svg"
            title11={
              <Fragment>
                <span className="home-text141"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Milestones"
            title1={
              <Fragment>
                <span className="home-text142">Documents</span>
              </Fragment>
            }
            thumbnail="/vector6114-6m1e.svg"
            title11={
              <Fragment>
                <span className="home-text143"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Trade"
            title1={
              <Fragment>
                <span className="home-text144">Dashboards</span>
              </Fragment>
            }
            thumbnail="/vector6114-yjl.svg"
            title11={
              <Fragment>
                <span className="home-text145"></span>
              </Fragment>
            }
          ></Feature>
          <Feature
            title="Wallet"
            title1={
              <Fragment>
                <span className="home-text146">Site Settings</span>
              </Fragment>
            }
            thumbnail="/vector6113-lvvs.svg"
            title11={
              <Fragment>
                <span className="home-text147"></span>
              </Fragment>
            }
          ></Feature>
        </div>
      </div>
      <div className="home-pricing">
        <div className="home-content17">
          <div className="home-header3">
            <div className="home-tag2">
              <span className="home-text148">Pricing plans</span>
            </div>
            <div className="home-heading14">
              <h2 className="home-text149">No setup cost or hidden fees.</h2>
            </div>
          </div>
          <div className="home-pricing-plans">
            <div className="home-plans1">
              <div className="home-plan1">
                <div className="home-top1">
                  <div className="home-heading15">
                    <span className="home-text150">Standard</span>
                    <span className="home-text151">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-cost1">
                    <span className="home-text152">Free</span>
                  </div>
                </div>
                <div className="home-bottom1">
                  <div className="home-check-list1">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-button1">
                    <span className="home-text153">Get Standard</span>
                  </div>
                </div>
              </div>
              <div className="home-plan2">
                <div className="home-top2">
                  <div className="home-heading16">
                    <span className="home-text154">Plus</span>
                    <span className="home-text155">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-cost2">
                    <span className="home-text156">$8</span>
                    <span className="home-text157">/month</span>
                  </div>
                </div>
                <div className="home-bottom2">
                  <div className="home-check-list2">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-button2">
                    <span className="home-text158">Get Standard</span>
                  </div>
                </div>
              </div>
              <div className="home-plan3">
                <div className="home-top3">
                  <div className="home-heading17">
                    <span className="home-text159">Premium</span>
                    <span className="home-text160">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-cost3">
                    <span className="home-text161">$16</span>
                    <span className="home-text162">/month</span>
                  </div>
                </div>
                <div className="home-bottom3">
                  <div className="home-check-list3">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-button3">
                    <span className="home-text163">Get Standard</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="home-expand1">
              <div className="home-overlay2">
                <div className="home-header4">
                  <div className="home-heading18">
                    <span className="home-text164">Expand</span>
                    <span className="home-text165">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt.
                    </span>
                  </div>
                  <div className="home-check-list4">
                    <div className="home-check1">
                      <svg viewBox="0 0 1024 1024" className="home-icon10">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text166">
                        Sed ut perspiciatis unde
                      </span>
                    </div>
                    <div className="home-check2">
                      <svg viewBox="0 0 1024 1024" className="home-icon12">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text167">
                        Quis nostrud exercitation ulla
                      </span>
                    </div>
                    <div className="home-check3">
                      <svg viewBox="0 0 1024 1024" className="home-icon14">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text168">
                        Duis aute irure dolor intuit
                      </span>
                    </div>
                  </div>
                </div>
                <div className="home-button4">
                  <span className="home-text169">
                    <span>Contact us</span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-plans2">
            <div className="home-plan4">
              <div className="home-top4">
                <div className="home-heading19">
                  <span className="home-text172">Standard</span>
                  <span className="home-text173">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-cost4">
                  <span className="home-text174">Free</span>
                </div>
              </div>
              <div className="home-bottom4">
                <div className="home-check-list5">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-button5">
                  <span className="home-text175">Get Standard</span>
                </div>
              </div>
            </div>
            <div className="home-plan5">
              <div className="home-top5">
                <div className="home-heading20">
                  <span className="home-text176">Plus</span>
                  <span className="home-text177">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-cost5">
                  <span className="home-text178">$8</span>
                  <span className="home-text179">/month</span>
                </div>
              </div>
              <div className="home-bottom5">
                <div className="home-check-list6">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-button6">
                  <span className="home-text180">Get Plus</span>
                </div>
              </div>
            </div>
            <div className="home-plan6">
              <div className="home-top6">
                <div className="home-heading21">
                  <span className="home-text181">Premium</span>
                  <span className="home-text182">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-cost6">
                  <span className="home-text183">$16</span>
                  <span className="home-text184">/month</span>
                </div>
              </div>
              <div className="home-bottom6">
                <div className="home-check-list7">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-button7">
                  <span className="home-text185">Get Plus</span>
                </div>
              </div>
            </div>
            <div className="home-expand2">
              <div className="home-overlay3">
                <div className="home-header5">
                  <div className="home-heading22">
                    <span className="home-text186">Expand</span>
                    <span className="home-text187">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt.
                    </span>
                  </div>
                  <div className="home-check-list8">
                    <div className="home-check4">
                      <svg viewBox="0 0 1024 1024" className="home-icon16">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text188">
                        Sed ut perspiciatis unde
                      </span>
                    </div>
                    <div className="home-check5">
                      <svg viewBox="0 0 1024 1024" className="home-icon18">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text189">
                        Quis nostrud exercitation ulla
                      </span>
                    </div>
                    <div className="home-check6">
                      <svg viewBox="0 0 1024 1024" className="home-icon20">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text190">
                        Duis aute irure dolor intuit
                      </span>
                    </div>
                  </div>
                </div>
                <div className="home-button8">
                  <span className="home-text191">
                    <span>Contact us</span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-help">
          <span className="home-text194">Need any help?</span>
          <div className="home-explore3">
            <span className="home-text195">
              Get in touch with us right away -&gt;
            </span>
          </div>
        </div>
      </div>
      <div className="home-testimonials">
        <div className="home-logo-container">
          <img
            alt="pastedImage"
            src="/pastedimage-idcu.svg"
            className="home-logo"
          />
        </div>
        <div className="home-content18">
          <div id="quotes" className="home-quotes">
            <div className="quote active-quote">
              <Quote rootClassName="quoteroot-class-name"></Quote>
            </div>
            <div className="quote">
              <Quote
                quote='"Testing these templates is a pleasure."'
                title="Developer @ Vista La Vista"
                author="Author 2"
                rootClassName="quoteroot-class-name"
              ></Quote>
            </div>
            <div className="quote">
              <Quote
                quote='"Wow, awesome works!'
                title="Designer @ OhBoy"
                rootClassName="quoteroot-class-name"
              ></Quote>
            </div>
          </div>
          <div className="home-buttons">
            <div id="quote-before" className="home-left">
              <svg viewBox="0 0 1024 1024" className="home-icon22">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div id="quote-next" className="home-right">
              <svg viewBox="0 0 1024 1024" className="home-icon24">
                <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
              </svg>
            </div>
          </div>
          <div>
            <div className="home-container3">
              <Script
                html={` <script>
    /* Quote Slider - Code Embed */

    let current = 1;

    const nextButton = document.querySelector("#quote-next");
    const previousButton = document.querySelector("#quote-before");
    const quotes = document.querySelectorAll(".quote");

    if (nextButton && previousButton && quotes) {
      nextButton.addEventListener("click", () => {
        quotes.forEach((quote) => {
          quote.classList.remove("active-quote");
        });

        current == quotes.length ? (current = 1) : current++;
        quotes[current - 1].classList.add("active-quote");
      });

      previousButton.addEventListener("click", () => {
        quotes.forEach((quote) => {
          quote.classList.remove("active-quote");
        });

        current == 1 ? (current = quotes.length) : current--;
        quotes[current - 1].classList.add("active-quote");
      });
    }
  </script>`}
              ></Script>
            </div>
          </div>
        </div>
      </div>
      <div className="home-faq">
        <div className="home-content19">
          <div className="home-header6">
            <div className="home-tag3">
              <span className="home-text196">
                <span>FAQ</span>
                <br></br>
              </span>
            </div>
            <div className="home-heading23">
              <h2 className="home-text199">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="home-rows">
            <div className="home-column4">
              <div className="Question">
                <span className="home-title2">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa
                  qui officia deserunt mollit anim id est laborum.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
              <div className="Question">
                <span className="home-title3">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description5">
                  <span>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Excepteur sint occaecat cupidatat non proident, sunt
                    in culpa qui officia deserunt mollit anim id est laborum.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span>
                    tempor incididunt ut labore et dolore magna aliqua.
                    Excepteur sint occaecat
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div className="home-question3 Question">
                <span className="home-title4">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description6">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna.
                </span>
              </div>
            </div>
            <div className="home-column5">
              <div className="home-question4 Question">
                <span className="home-title5">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description7">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna.
                </span>
              </div>
              <div className="home-question5 Question">
                <span className="home-title6">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description8">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna.
                </span>
              </div>
              <div className="home-question6 Question">
                <span className="home-title7">
                  What is sit amet, consectetur adipiscing elit, sed do?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-description9">
                  <span>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Excepteur sint occaecat cupidatat non proident, sunt
                    in culpa qui officia deserunt mollit anim id est laborum.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span>
                    tempor incididunt ut labore et dolore magna aliqua.
                    Excepteur sint occaecat
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-get-started2">
        <div className="home-content20">
          <div className="home-heading24">
            <h2 className="home-text206">
              Let’s take your business online in just 3 days.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </h2>
            <span className="home-text207">
              We build, launch, and manage your professional business website
              and SaaS tools — all done-for-you. You relax, we handle
              everything.
            </span>
          </div>
          <div className="home-hero-buttons2">
            <div className="home-ios-btn2">
              <span className="home-caption7">Get My Website Now</span>
            </div>
            <div className="home-android-btn2">
              <span className="home-caption8">Free Trial (Digital WebApp)</span>
            </div>
          </div>
        </div>
      </div>
      <Footer
        link="Profession Website Development"
        text="© 2025 TechPlanes. All Rights Reserved."
        link1="Profession Email Setup"
        link2="Digital Business Management WebApp"
        link3="Social Media Marketing"
        link4="Mobile App Developement"
        link6="Contact Us"
        link8="Offices"
        link9="Terms &amp; Conditions"
        text1="Subsidiary of Jarajoy Company Limited"
        pastedImageSrc="/techplanes_1.svg"
      ></Footer>
    </div>
  )
}

export default Home
